<template>
  <Popup :popup="popup" class="popup-account-blocked" :close="false">
    <div class="content">
      <img src="@/asset/icon/account-deleted.svg" class="popup-img" alt="">
      <h1>{{ $t('account.deleted.title') }}</h1>
      <p>
        {{ $t('account.deleted.description') }}
      </p>
    </div>
    <div class="actions">
      <BamLink class="btn btn-danger close-button" :to="ROUTE.home">
        <span>{{ $t('common.close') }}</span>
      </BamLink>
    </div>
  </Popup>
</template>

<script setup>
import { ROUTE } from '@/facade/enum.js';
import { POPUP, Popup } from '@/hook/system/popup.js';
import BamLink from 'bambam-router/component/BamLink.vue';

const popup = POPUP.Banned;
</script>
